function SettingsIcon(props) {
  return (
    <svg id='SettingsIcon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35.165 29.361' {...props}>
      <g id='Raggruppa_398' data-name='Raggruppa 398' transform='translate(-3 -7)'>
        <path
          id='Tracciato_388'
          data-name='Tracciato 388'
          d='M20.582,34.361H6.487A2.479,2.479,0,0,1,4,31.889V10.471A2.479,2.479,0,0,1,6.487,8h28.19a2.479,2.479,0,0,1,2.487,2.471v8.934'
          fill='none'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          id='Tracciato_389'
          data-name='Tracciato 389'
          d='M4,11A2.78,2.78,0,0,1,6.487,8h28.19a2.78,2.78,0,0,1,2.487,3v9H4Z'
          fill='none'
          stroke='#fff'
          strokeWidth='2'
        />
        <circle
          id='Ellisse_30'
          data-name='Ellisse 30'
          cx='2'
          cy='2'
          r='2'
          transform='translate(8 16) rotate(-90)'
          fill='#fff'
        />
        <circle
          id='Ellisse_31'
          data-name='Ellisse 31'
          cx='2'
          cy='2'
          r='2'
          transform='translate(15 16) rotate(-90)'
          fill='#fff'
        />
        <circle
          id='Ellisse_32'
          data-name='Ellisse 32'
          cx='2.5'
          cy='2.5'
          r='2.5'
          transform='translate(29 27)'
          fill='none'
          stroke='#fff'
          strokeWidth='3'
        />
        <path
          id='Tracciato_390'
          data-name='Tracciato 390'
          d='M35.569,38.676V35.34m0-5V27m-4.631,8.757,2.646-1.668m3.97-2.5L40.2,29.919m-9.263,0,2.646,1.668m3.97,2.5L40.2,35.757'
          transform='translate(-3.974 -3.316)'
          fill='none'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </g>
    </svg>
  )
}

export default SettingsIcon
